
import React from 'react';
import { connect } from 'react-redux';
import { Input, Button } from 'reactstrap';
import { setLoginPage, setForgetPasswordDetails, setSiteKey, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Swal from 'sweetalert2';
import SignUpComponent from './SignUpComponent';
import GeneralUtils from '../../Utils/generalUtils.js';
import { FaArrowRight } from 'react-icons/fa';

class BillPayAmountComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            verified: false,
            siteKey: "",
            billingName: "",
            accountId: "",
            paypalClientId: "",
            transactionId: "",
            outstandingAmount: "",
            amount: "",
            diffAmount: "",
            phoneNumber: "NA",
            plugNPayInitialResponse: {}
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        // Network.executeAxios("getRecaptchaSiteKey", "GET", "", (resp) => {
        //         this.props.setSiteKey("siteKey", resp.SITEKEY);
        //         this.setState({
        //             isLoading:false
        //         })
        //     });

        window.addEventListener('message', this.processMessage, false);
        this.populateAccountDetails()
        Network.executeAxios("getPaypalClientId", "GET", "", (response) => {

            this.setState({
                paypalClientId: response.CLIENT_ID
            })
        });
    }

    generateReceiptNumber = () => {
        var number = Math.floor(100000 + Math.random() * 900000);
        number = "SCM" + number;
        return number;
    }

    processMessage = (event) => {
        if (event.data.type && event.data.type === "paypal") {
            this.setState({ isLoading: true })
            var response = event.data.details;
            var receiptNumber = this.generateReceiptNumber();
            if (response.status === "COMPLETED") {   // success case
                console.log("Paypal response>>", response)
                this.state.transactionId = response.purchase_units[0].payments.captures[0].id;   //transaction or capture id
                var temp = {
                    "billingName": this.state.billingName,
                    "accountId": this.state.accountId,
                    "amount": this.state.amount,
                    "transactionId": this.state.transactionId
                }
                this.props.setUserRegisterDetails("accountDetails", temp);
                this.handlePostTransactionOfChannels("9", "PAYPAL", receiptNumber);
                //this.props.setLoginPage("pageName", "transactionForBillPay");
            } else {
                this.paymentFailedProcess("PAYPAL", receiptNumber)
            }
        } else {
            console.log("message => ", event.data);
        }

    }

    handlePostTransactionOfChannels(paymentTypeId, paymentTypeName, receiptNumber) {
        var dataToSend = {
            profileId: this.state.profileId,
            accountId: this.state.accountId,
            firstName: this.state.billingName,
            lastName: this.state.billingName,
            emailID: this.state.emailId,
            phoneNumber: this.state.phoneNumber,
            amount: GeneralUtils.formatNumberToStandardForm(this.state.amount),
            diffAmount: GeneralUtils.formatNumberToStandardForm(this.state.diffAmount),
            transactionId: this.state.transactionId,
            token: this.state.token,
            paymentType: paymentTypeName,
            fundingSource: this.state.fundingSource,
            billAmount: GeneralUtils.formatNumberToStandardForm(this.state.amount),
            paymentMethodId: paymentTypeId,
            cardExpiryDate: this.state.expiryDate,
            receiptNumber: receiptNumber,
            cardType: this.state.cardType

        }
        Network.executeAxios("makePaymentOrderWOL", "POST", dataToSend, (makePaymentOrderResponse) => {
            this.setState({ isLoading: false })
            if (makePaymentOrderResponse.STATUS === "SUCCESS") {
                Swal.fire({
                    title: this.props.locales.paymentSuccessTitleInSwal,
                    text: this.props.locales.paymentCreditTextInSwal,
                    type: '',
                    timer: 2000,
                    showCancelButton: false,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                }).then((result) => {
                    this.props.setLoginPage("pageName", "transactionForBillPay");
                });
            } else {
                this.refundOfTransaction(paymentTypeName);
            }
        });
    }

    refundOfTransaction(paymentTypeName) {
        this.setState({ isLoading: false })
        Swal.fire({
            title: this.props.locales.paymentFailureTitleInSwal,
            text: this.props.locales.paymentRefundtTextInSwal,
            type: '',
            showCancelButton: false,
            confirmButtonText: this.props.locales.okButtonTextInSwal,
        }).then((result) => {
            var refundData = {
                transactionId: this.state.transactionId,
                amount: GeneralUtils.formatNumberToStandardForm(this.state.finalPaymentAmount)
            }
            if (paymentTypeName == "PAYPAL") {
                Network.executeAxios("paypalRefundPayment", "POST", refundData, (makePaymentOrderResponse) => {
                    window.location.reload();
                });

            }

        });
    }

    handleFinalMakePaymentResponse = (response) => {
        var dataToSend = {
            email: this.state.emailId,
            transactionId: this.state.transactionId,
            orderId: this.state.finalOrderId
        }
        Network.executeAxios("insertOrderId", "POST", dataToSend, (Response) => {
            this.setState({ isLoading: false })
            Swal.fire({
                title: this.props.locales.paymentSuccessTitleInSwal,
                text: this.props.locales.paymentCreditTextInSwal,
                type: '',
                timer: 2000,
                showCancelButton: false,
                confirmButtonText: this.props.locales.okButtonTextInSwal,
            }).then((result) => {
                this.props.setLoginPage("pageName", "transactionForBillPay");
            });
        });
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    populateAccountDetails() {
        if (this.props.userRegisterDetails.accountDetails.account_id) {
            this.setState({ accountId: this.props.userRegisterDetails.accountDetails.account_id })
        }
        if (this.props.userRegisterDetails.accountDetails.billing_name) {
            this.setState({ billingName: this.props.userRegisterDetails.accountDetails.billing_name })
        }
        var outstandingAmount = ""
        try {
            outstandingAmount = this.props.userRegisterDetails.accountDetails.balance_details.outstanding_balance
        } catch (err) {

        }


        this.setState({
            amount: GeneralUtils.formatNumberToStandardForm(outstandingAmount),
            diffAmount: "",
            outstandingAmount: GeneralUtils.formatNumberToStandardForm(outstandingAmount)
        })
    }


    handleInputValueChange(name, value) {
        this.state.finalPaymentAmount = value
        this.state.amount = value
        var receivedAmount = parseFloat((this.state.outstandingAmount.replace(',', '')))
        if (parseFloat(this.state.finalPaymentAmount) > (parseFloat(receivedAmount))) {
            var diffAmount = parseFloat(this.state.finalPaymentAmount) - parseFloat(receivedAmount)
        }

        this.setState({
            diffAmount: diffAmount
        });
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    onVerify = recaptchaResponse => {
        this.setState({
            verified: true
        });
    };

    fetchAccountDetails() {
        if (ValidateForm.inputFieldMandatoryCheck("otpCustomerIdContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("otpCustomerIdContainer", this.props.locales, false)) {
                var temp = {
                    "billingName": this.state.billingName,
                    "accountId": this.state.accountId,
                    "amount": this.state.amount
                }
                this.props.setUserRegisterDetails("accountDetails", temp);
                this.props.setLoginPage("pageName", "transactionForBillPay");
            }
        }

    }


    plugNpayBtnClicked() {
        this.setState({ isLoading: true })
        var dataToSend = {
            "billingName": this.state.billingName,
            "accountId": this.state.accountId,
            "amount": this.state.amount
        }
        Network.executeAxios("payBillWithPlugNPayWOL", "POST", dataToSend, (Response) => {
            this.setState({ isLoading: false, plugNPayInitialResponse: Response });
            window.location.replace("./plugNPay.html?responseData=" + encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse)));
        });
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetUsernameOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetUsernameOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.billPaymentComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )

    }


    billPaymentComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                <div className="col-md-12 row py-5 m-0 my-5 d-none d-sm-block">

                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-sm-5 pl-2 pt-4" id="otpCustomerIdContainer">
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.hiInBillPayamountPart},</div>
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 600 }}>{this.state.billingName} ({this.state.accountId})</div>
                        <div className="col-md-12 pb-4 pt-2" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.enterAmountToPayTextInBillPayAmountPart}</div>
                        <div className="form-group col-md-12" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.amountInBillPayAmountPart}</label>
                            <Input type="text" name="amount" autoComplete="new-password" style={{ color: '#404042' }}
                                className="loginCredItem input_data mandatoryFieldSpecial typeNumber pt-4 pb-3" placeholder={this.props.locales.enterAmountInBillPayAmountPart}
                                onChange={(event) => this.handleInputValueChange("amount", event.target.value)}
                                value={this.state.amount}
                                onKeyUp={(event) => this.displayLabel(event, this.state.amount, this.props.locales.enterAmountInBillPayAmountPart)} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        {/* <div className="form-group col-md-12 d-none" >
                            <label className="d-none animated slideInUp m-0"style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.forgetPswUserNamePINLabel}</label>
                            <Input type="text" name="pin" autoComplete="new-password"  style={{color:'#404042'}} 
                            className="loginCredItem input_data mandatoryFieldSpecial typeNumber pt-4 pb-3" placeholder={this.props.locales.forgetPswUserNamePINPlc}
                            onChange={(event) => this.inputValueChange("pin", event.target.value)}
                            onKeyUp={(event) => this.displayLabel(event)} />
                            <div className="errorDesc" style={{color:'red',fontSize:12,fontWeight:400,position:'absolute'}}></div>
                        </div> */}


                        {parseFloat(this.state.diffAmount) > 0 ?
                            <div className="col-md-12" style={{ fontSize: 14, color: '#58595B' }}>${GeneralUtils.formatNumberToStandardForm(this.state.diffAmount)} {this.props.locales.paymentInBillPayAmountPart}
                            </div>
                            : null}

                        {parseFloat(this.state.amount) > 0 ?
                            // <div className="col-md-12 p-0">
                            //      <div className="tsysContainer pt-4" style={{ height: 100 }}>
                            //          <iframe title="paypalMethod" src={"./PayPal.html?clientId=" + this.state.paypalClientId + "&amount=" + this.state.amount} style={{ width: '100%', border: 'none' }} frameBorder="0"> </iframe>
                            //      </div>
                            //  </div>
                            <div className="col-md-12 px-3 pt-4">
                                <Button className="pluNPayBtn animated fadeIn" onClick={() => { this.plugNpayBtnClicked() }}>
                                    Pay&nbsp;<FaArrowRight />
                                </Button>
                            </div>
                            : null}


                        <div className="d-flex col-md-12 justify-content-center pb-5">
                            <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.signInLinkClicked() }}> {this.props.locales.singInUsingOtpInBillPayAmountPart}</div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

    signInLinkClicked() {
        this.props.setLoginPage("pageName", "customerIdForOTP");
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        siteKey: state.siteKey,
        userRegisterDetails: state.userRegisterDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setSiteKey: function (key, payload) {
            dispatch(setSiteKey(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const BillPayAmountComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(BillPayAmountComponent)


export default BillPayAmountComponentContainer;